import { put, takeLatest, call } from 'redux-saga/effects'
import API from "store/projectCreation/projectCreationApis";
import * as types from "store/projectCreation/projectCreationTypes";
import history from 'routes/history'


 function* createProject({payload : payload}) {
  try {
    const response = yield call(API.createProjectRequest,payload)
   if ( response.status === 200 ) {
      yield put({type:'POST_CREATE_PROJECT_SUCCEEDED', payload: response});
      yield put({type:'CLEAR_PROJECT_INQUIRY'});
      history.push(`/projects/${response.data.id}/dashboard`)
    } else if (response.status === 401) {
        yield put({type:'UNAUTHORIZED'})
    } else {
        yield put({type: 'POST_CREATE_PROJECT_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("Create project request failed: ",err);
       yield put({type:'POST_CREATE_PROJECT_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}

export default function* watchCreateProject () {
  yield takeLatest(types.POST_CREATE_PROJECT, createProject);
}
